<template>
  <div class="relative hide-scroll">
    <div v-if="isShowHeader" class="h-header-app w-full z-50 sticky top-0">
      <head-title @onViewLoadApp="onViewLoadApp"></head-title>
    </div>

    <div :class="[isShowHeader ? 'h-body-app' : 'h-[100vh]']" class="w-full">
      <router-view />
    </div>

    <!-- Loading app -->

    <!-- <accept-view></accept-view> -->
  </div>
  <!-- <div>
    <ScreenSize></ScreenSize>
  </div> -->
  <div
    v-show="isShowIconApp"
    class="absolute z-50 top-0 left-0 img-app items-center flex w-full h-full justify-center"
  >
    <LoadApp
      :urlImage="icUrlApp"
      :codeColor="colorApp"
      :bgColor="bgColorApp"
    ></LoadApp>
  </div>
</template>

<script>
// import ScreenSize from "./layout/error-screen/screen-size";
import LoadApp from "./layout/loading/load-app";
import { mapActions, mapMutations } from "vuex";
import headTitle from "./layout/header/head-title.vue";
// import { auth, signOut } from "./configs/firebase.js";
export default {
  components: {
    // ScreenSize,
    LoadApp,
    headTitle,
    // AcceptView,
  },
  name: "App",

  data() {
    return {
      screamValue: 1,
      apiCompleted: false,
      isShowIconApp: true,
      icUrlApp: require("@/assets/icon_svg/logo.svg"),
      colorApp: "#FF828A",
      bgColorApp: "linear-gradient(#4D85D4,#06278A)",
    };
  },

  computed: {
    isShowHeader() {
      return this.$store.state.signModule.isHeader;
    },
  },

  async mounted() {
    setTimeout(async () => {
      this.isShowIconApp = false;
    }, 4000);
  },

  async created() {
    // signOut(auth)
    //   .then(() => {
    //     console.log("Sign-out successful");
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //     // An error happened.
    //   });
    await this.getListStaticRegister();
    await this.getListPromptRegister();
    const oAuth2Id = localStorage.getItem("oAuth2IdV2");
    debugger;

    console.log("process.env", process.env);
    if (oAuth2Id) {
      try {
        const resultData = await this.loginApp({ oAuth2Id: oAuth2Id });
        if (resultData.token) {
          await Promise.all([
            this.getListLifeStyleCommons(),
            this.getListInformationBasic(),
            this.getListLifeStyleStatic(),
            this.getListReasonReport(),
          ]).then(async () => {
            this.getDetailUser(), this.setInformationUserAdmin(resultData.user);
            this.handleRouterNavigation();
          });
        } else {
          // Xử lý khi không nhận được token
          // this.$router.push({ path: "/" });
        }
      } catch (error) {
        console.error(error);
        // this.$router.push({ path: "/" });
        // localStorage.clear();
      }
    } else {
      this.setShowLogin(true);
      // localStorage.setItem("showLogin", false);
      // this.$router.push({ path: "/" }).catch(() => {});
      // localStorage.clear();
    }
  },

  // watch: {
  //   apiCompleted(newValue) {
  //     if (newValue) {
  //       this.handleRouterNavigation();
  //     }
  //   },
  // },

  methods: {
    ...mapActions([
      "loginApp",
      "getListLifeStyleCommons",
      "getListInformationBasic",
      "getListLifeStyleStatic",
      "getListReasonReport",
      "getDetailUser",
      "setCompleteUser",
      "getListPromptRegister",
      "getListStaticRegister",
      "getListRecommends",
    ]),

    ...mapMutations(["setShowLogin", "setInformationUserAdmin"]),
    onViewLoadApp() {
      this.isShowIconApp = true;
      localStorage.setItem("valueRouter", "introduction-view");
      // this.$router.push({ path: "/" }).catch(() => {});
      setTimeout(async () => {
        this.isShowIconApp = false;
      }, 3000);
    },
    handleResize() {
      if (
        768 <= parseInt(window.innerWidth) &&
        parseInt(window.innerWidth) <= 2560 &&
        parseInt(window.innerHeight) >= 600
      ) {
        this.screamValue = 0;
      } else if (
        parseInt(window.innerWidth) <= 900 &&
        parseInt(window.innerHeight) >= 600
      ) {
        this.screamValue = 1;
      } else {
        this.screamValue = 2;
      }
    },

    async handleRouterNavigation() {
      debugger;
      const routerName = localStorage.getItem("valueRouter");
      if (routerName === "package-view") {
        this.$router.push({ path: "/package" });
      } else if (routerName === "features-view") {
        this.$router.push({ path: "/features" });
      } else if (routerName === "about-view") {
        this.$router.push({ path: "/about" });
      } else if (routerName === "edit-profile-view") {
        // await this.getDetailUser();
        this.$router.push({
          path: "/profile/edit-profile",
          query: {
            namePage: "Edit profiles",
          },
        });
      } else if (routerName === "setting-profile-view") {
        this.$router.push({
          path: "/profile/setting-profile",
          query: {
            namePage: "Settings",
          },
        });
      } else if (routerName === "package-default-view") {
        this.$router.push({
          path: "/profile/default",
          query: {
            namePage: "Heart-Connect Package",
          },
        });
      } else if (routerName === "package-plus-view") {
        this.$router.push({
          path: "/profile/plus",
          query: {
            namePage: "Heart-Connect Plus",
          },
        });
      } else if (routerName === "package-gold-view") {
        this.$router.push({
          path: "/profile/gold",
          query: {
            namePage: "Heart-Connect Gold",
          },
        });
      } else if (routerName === "package-platinum-view") {
        this.$router.push({
          path: "/profile/platinum",
          query: {
            namePage: "Heart-Connect Platinum",
          },
        });
      } else if (routerName === "detail-admin-view") {
        this.$router.push({
          path: "/profile/detail-admin",
          query: {
            namePage: "Detail Admin",
          },
        });
      } else if (routerName === "looking-view") {
        this.$router.push({
          path: "/profile/looking-love",
          query: {
            namePage: "Looking for love",
          },
        });
      } else if (routerName === "friend-view") {
        this.$router.push({
          path: "/profile/let-friend",
          query: {
            namePage: "Let's be friend",
          },
        });
      } else if (routerName === "coffee-view") {
        this.$router.push({
          path: "/profile/coffee-date",
          query: {
            namePage: "Coffee Date",
          },
        });
      } else if (routerName === "tool") {
        this.$router.push({
          path: "/profile/tool",
          query: {
            namePage: "Tool",
          },
        });
      } else {
        this.getListRecommends({
          pageSize: 100,
          currentPage: 0,
        });
        this.$router.push({
          path: "/profile/feed",
          query: {
            namePage: "Feed",
          },
        });
      }
    },
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style lang="scss">
@import "./assets/css/common.scss";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.h-header-app {
  background-color: #1d3656;
  height: 70px;
}
.h-body-app {
  height: calc(100vh - 70px);
}
</style>
